import React from 'react';
import { useParams } from 'react-router-dom';

// TODO: Migrate Debug page from antd to ShadCN/Tailwind
const Debug = () => {
    const { jobId } = useParams();

    return (
        <div className="p-8">
            <h2 className="text-2xl font-bold mb-4">Debug Information</h2>
            <p className="text-muted-foreground">Job ID: <code className="bg-muted px-2 py-1 rounded text-sm">{jobId}</code></p>
            <p className="text-muted-foreground mt-4">Debug page is being rebuilt. Check back soon.</p>
        </div>
    );
};

export default Debug;
